// src/components/PinchIcon.jsx
// Refreshed pinch icon — two converging strokes meeting at a focal point.
// Sized via currentColor + props.
//
// CLAUDE CODE: To convert this file for a real React app:
//   1. Prepend:  import React from "react";
//   2. Change function declaration to: export default function PinchIcon(...)
//   3. Delete the `window.PinchIcon = PinchIcon;` line at the bottom.

import React from "react";

function PinchIcon({ size = 18, strokeWidth = 2 }) {
  return (
    <svg
      width={size}
      height={size * (14 / 20)}
      viewBox="0 0 20 14"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M2 1.5 C4.5 1.5 8 8.5 10 11.5" />
      <path d="M18 1.5 C15.5 1.5 12 8.5 10 11.5" />
      <circle cx="10" cy="11.5" r="1.4" fill="currentColor" stroke="none" />
    </svg>
  );
}
export default PinchIcon;
